import { Component, OnDestroy, OnInit } from "@angular/core";
import { PortalAdminService } from "../../services/portal-admin-service/portal-adimin.service";

import { Customer } from "../../models/customer.model";
import { Permission } from "../../models/permission.model";
import {
  UserPermission,
  SpecialProgram,
} from "../../models/userPermission.model";

import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { distinctUntilChanged, debounceTime, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Subscription } from "rxjs/internal/Subscription";

@Component({
    selector: "pa-permission",
    templateUrl: "./permission.component.html",
    styleUrls: ["./permission.component.scss"],
    standalone: false
})
export class PermissionComponent implements OnInit, OnDestroy {
  isEdit = false;
  isLoading: boolean;

  companies: Customer[];
  company;
  permissions: Permission[];
  userIndex: number;
  users: UserPermission[];
  searchUsersArry: UserPermission[];
  companyHoldingId: string;
  userSearch;
  noResults = false;
  usersIsDone: boolean;
  noUsers: boolean;
  permissionIsDone: boolean;
  noPermissions: boolean;

  searchSubscriptions: Subscription[] = [];

  public keyUp = new Subject<KeyboardEvent>();
  private onDestroy$ = new Subject<void>();

  constructor(
    private portalAdminService: PortalAdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    const storedSelectedCompany = localStorage.getItem("selectedCompany");
    if (storedSelectedCompany) {
      this.company = JSON.parse(storedSelectedCompany);
      this.selectCompany();
    }

    this.keyUp
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((event: KeyboardEvent) => {
        if (
          !!this.company &&
          event.code !== "ArrowDown" &&
          event.code !== "ArrowUp" &&
          event.code !== "ArrowLeft" &&
          event.code !== "ArrowRight" &&
          event.code !== "Enter" &&
          event.code !== "Tab"
        ) {
          this.getCompanyMatchesList(event);
        }
      });
  }

  ngOnInit() {}

  getCompanyMatchesList(search) {
    this.isLoading = true;
    this.searchSubscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.searchSubscriptions.push(
      this.portalAdminService
        .getCustomers(this.company)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((companyRes: Customer[]) => {
          this.companies = companyRes;
          this.noResults = false;
          if (companyRes.length === 0) {
            this.isLoading = false;
            this.noResults = true;
          }
        })
    );
  }

  searchEvent(event: KeyboardEvent) {
  if (event.altKey) {
    return;
  }
  if (event.code === "Enter" || event.code === "Tab") {
    if (this.company && typeof this.company === 'object' && this.company.holdingAccountId) {
      this.selectCompany();
    }
  } else {
    this.keyUp.next(event);
  }
}

  selectCompany() {
    this.isLoading = true;
    this.noPermissions = undefined;
    this.noUsers = undefined;
    if (this.company) {
      this.permissions = [];
      localStorage.setItem("selectedCompany", JSON.stringify(this.company));
      const tempCompany = { ...this.company };
      this.companyHoldingId = this.company.holdingAccountId;
      this.company = tempCompany.customerName;
      this.users = [];
      this.usersIsDone = false;
      this.portalAdminService
        .getUserPermissions(this.companyHoldingId)
        .subscribe(
          (userRes: UserPermission[]) => {
            this.isLoading = false;
            if (userRes.length <= 0) {
              this.noUsers = true;
              this.usersIsDone = true;
            } else {
              this.noUsers = false;
              this.users = userRes;
              this.searchUsersArry = userRes;
              this.usersIsDone = true;
            }
          },
          (err: HttpErrorResponse) => {
            this.isLoading = false;
            console.log(err);
            if (err.status === 403 || err.status === 401) {
              this.router.navigate(["/access-denied"]);
            } else {
              this.router.navigate(["/error"]);
            }
          }
        );
      this.permissions = [];
      this.permissionIsDone = false;
      this.portalAdminService.getPermissions(this.companyHoldingId).subscribe(
        (permissionRes: Permission[]) => {
          if (permissionRes.length > 0) {
            for (const permiss of permissionRes.filter((x) => x.isSecured)) {
              switch (permiss.code.toLowerCase()) {
                case "clbintegrator_sso":
                case "clblocksmith_sso":
                case "clbsinglefamily_sso":
                  break;
                default:
                  this.permissions.push(permiss);
              }
            }
          }

          this.noPermissions = this.permissions.length > 0 ? false : true;
          this.permissionIsDone = true;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.log(err);
          if (err.status === 403 || err.status === 401) {
            this.router.navigate(["/access-denied"]);
          } else {
            this.router.navigate(["/error"]);
          }
        }
      );
    }
  }

  contentLoaded() {
    if (
      this.permissionIsDone === true &&
      this.usersIsDone === true &&
      this.noUsers === false &&
      this.noPermissions === false
    ) {
      return true;
    } else {
      return false;
    }
  }

  isChecked(userId: number, permission: Permission, index: number): boolean {
    if (this.users[index].specialPrograms.length === 0) {
      return false;
    } else {
      if (userId === this.users[index].userId) {
        for (const special of this.users[index].specialPrograms) {
          if (special.specialProgramId === permission.databaseId) {
            return true;
          }
        }
        return false;
      }
    }
  }

  searchUsers(event) {
    const results = this.searchUsersArry.filter((user) => {
      const userName = `${user.firstName} ${user.lastName}`;
      if (userName.toUpperCase().includes(this.userSearch.toUpperCase())) {
        return true;
      } else {
        return false;
      }
    });
    this.users = results;
  }

  clearSearch() {
    this.userSearch = "";
    const results = this.searchUsersArry.filter((user) => {
      if (
        user.firstName.toUpperCase().includes(this.userSearch.toUpperCase())
      ) {
        return true;
      } else {
        return false;
      }
    });
    this.users = results;
  }

  checkboxSelected(
    event: MatCheckboxChange,
    permission: Permission,
    selectedUser: UserPermission
  ) {
    if (event.checked === true) {
      for (const user of this.users) {
        if (user.auth0Identifier === selectedUser.auth0Identifier) {
          const specialProgramObj: SpecialProgram = {
            userAccessId: 0,
            specialProgramId: permission.databaseId,
            programName: permission.name,
            programCode: permission.code,
            role: "user",
          };
          user.specialPrograms.push(specialProgramObj);
        }
      }
    } else if (event.checked === false) {
      for (const user of this.users) {
        if (user.auth0Identifier === selectedUser.auth0Identifier) {
          user.specialPrograms.forEach((userSpecialProgram, index) => {
            if (permission.databaseId === userSpecialProgram.specialProgramId) {
              user.specialPrograms.splice(index, 1);
            }
          });
        }
      }
    }
  }

  editUser(index: number) {
    this.userIndex = index;
    this.isEdit = true;
  }

  saveUserChanges(index: number, userSave: UserPermission) {
    this.isLoading = true;
    if (userSave.userId === 0) {
      for (const user of this.users) {
        if (user.auth0Identifier === userSave.auth0Identifier) {
          this.portalAdminService
            .addUserPermissions(this.companyHoldingId, user)
            .subscribe((updateRes) => {
              this.portalAdminService
                .getUserPermissions(this.companyHoldingId)
                .subscribe((userRes: UserPermission[]) => {
                  this.users = userRes;
                  this.isLoading = false;
                  this.snackBar.open("User Permissions Updated", "", {
                    duration: 2250,
                  });
                });
            });
        }
      }
    } else if (userSave.userId !== 0) {
      for (const user of this.users) {
        if (user.auth0Identifier === userSave.auth0Identifier) {
          this.portalAdminService
            .updateUserPermissions(this.companyHoldingId, user)
            .subscribe((updateRes) => {
              this.portalAdminService
                .getUserPermissions(this.companyHoldingId)
                .subscribe((userRes: UserPermission[]) => {
                  this.users = userRes;
                  this.isLoading = false;
                  this.snackBar.open("User Permissions Updated", "", {
                    duration: 2250,
                  });
                });
            });
        }
      }
    }
    this.userIndex = -1;
    this.isEdit = false;
  }

  deleteUser(index: number, userDelete: UserPermission) {
    for (const user of this.users) {
      if (user.auth0Identifier === userDelete.auth0Identifier) {
        user.specialPrograms = [];
        this.portalAdminService
          .updateUserPermissions(this.companyHoldingId, user)
          .subscribe((updateRes) => {
            this.portalAdminService
              .getUserPermissions(this.companyHoldingId)
              .subscribe((userRes: UserPermission[]) => {
                this.users = userRes;
              });
          });
      }
    }
    this.userIndex = -1;
    this.isEdit = false;
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
